import { get } from 'lodash/fp';

import { SELF_EVALUATION_ENDPOINT } from 'config';

function getCarLeadHashFromURL(url) {
  try {
    return url.split(SELF_EVALUATION_ENDPOINT)[1].split('/')[1];
  } catch (_) {
    return null;
  }
}

const isEmptyHash = (hash) => !hash || hash === 'undefined';
const getURL = get(['request', 'url']);

const isURLWithEmptyCarLeadHash = (url) =>
  url.includes(SELF_EVALUATION_ENDPOINT) &&
  isEmptyHash(getCarLeadHashFromURL(url));

const isAPICallWithEmptyCarLeadHash = (action) =>
  action.request && isURLWithEmptyCarLeadHash(getURL(action));

function createMessage(action) {
  const data = JSON.stringify({
    ssr: typeof window === 'undefined',
    url: getURL(action),
  });

  return `Self-evaluation endpoint was called with undefined car lead hash: ${data}`;
}

/**
 * @param {(error: Error) => Promise} log
 */
export function createEmptyCarLeadHashLoggerMiddleware(log) {
  return () => (next) => (action) => {
    if (isAPICallWithEmptyCarLeadHash(action)) {
      log(new Error(createMessage(action)));
    }

    return next(action);
  };
}
